import HelpIcon from "@mui/icons-material/HelpOutlineRounded";
import { Box, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { useState } from "react";
import useClientContext from "../../../contexts/useClientContext";
import SwipeableBottomDrawer from "../../common/SwipeableBottomDrawer";
import SupportInfo from "../SupportInfo";
import SwipeableBottomDrawerHeader from "./SwipeableBottomDrawerHeader";

const HelpSupportRow = () => {
  const { portalSettings } = useClientContext();
  const [open, setOpen] = useState(false);

  if (!portalSettings?.supportEmail && !portalSettings?.supportPhone) {
    return null;
  }

  return (
    <>
      <ListItemButton onClick={() => setOpen(true)} sx={{ py: 1.5, pl: 3 }}>
        <ListItemIcon sx={(theme) => ({ minWidth: theme.spacing(4) })}>
          <HelpIcon color="secondary" />
        </ListItemIcon>
        <ListItemText>Help & Support</ListItemText>
      </ListItemButton>
      <SwipeableBottomDrawer open={open} onClose={() => setOpen(false)}>
        <SwipeableBottomDrawerHeader title="Help & Support" onClose={() => setOpen(false)} />
        <Box sx={{ px: 2, py: 3 }}>
          <SupportInfo isMobile email={portalSettings?.supportEmail} phone={portalSettings?.supportPhone} />
        </Box>
      </SwipeableBottomDrawer>
    </>
  );
};

export default HelpSupportRow;
